var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainExplainImgbillions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 130.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-2{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.85,69.55v1.94c0,3.44-2.22,5.7-5.66,5.7h-6.04v-23.87h5.73c3.44,0,5.66,2.25,5.66,5.7v1.26c0,2.15-.85,3.68-2.42,4.57,1.74.82,2.73,2.42,2.73,4.71Zm-8.08-12.82v6.48h1.6c1.74,0,2.56-.82,2.56-2.56v-1.71c0-1.4-.82-2.22-2.22-2.22h-1.94Zm4.47,12.45c0-1.74-.82-2.56-2.56-2.56h-1.91v7.16h2.25c1.4,0,2.22-.82,2.22-2.22v-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.12,53.31h3.61v23.87h-3.61v-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.69,53.31h3.61v20.46h6.45v3.41h-10.06v-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.55,53.31h3.61v20.46h6.45v3.41h-10.06v-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.4,53.31h3.61v23.87h-3.61v-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.67,71.76v-13.03c0-3.44,2.32-5.76,5.8-5.76s5.8,2.32,5.8,5.76v13.03c0,3.45-2.32,5.76-5.8,5.76s-5.8-2.32-5.8-5.76Zm7.98,0v-13.03c0-1.5-.85-2.35-2.18-2.35s-2.18.85-2.18,2.35v13.03c0,1.5.85,2.35,2.18,2.35s2.18-.85,2.18-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.91,53.31h3.99l4.6,16.03v-16.03h3.55v23.87h-3.82l-4.77-15.28v15.28h-3.55v-23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.18,71.66v-.85l3.48-.38v.89c0,1.74.89,2.8,2.32,2.8s2.32-.89,2.32-2.29c0-1.5-.61-2.59-3.31-5.15-3.58-3.38-4.6-5.22-4.6-7.84,0-3.55,2.05-5.87,5.49-5.87s5.49,2.32,5.49,5.9v.61l-3.48.38v-.68c0-1.84-.72-2.8-1.98-2.8s-1.98.78-1.98,2.28.75,2.59,3.31,5.15c3.48,3.48,4.6,5.22,4.6,7.84,0,3.41-2.39,5.87-5.83,5.87s-5.83-2.46-5.83-5.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainExplainImgbillions);
export default __webpack_public_path__ + "static/media/main_explain_img.billions.fca525d80daeae5fd2133faff206fe0f.svg";
export { ForwardRef as ReactComponent };